<h1 *ngIf="!isSpecificRoute">page-not-found works!</h1>
<router-outlet  (activate)="onActivate($event)"></router-outlet>
